export enum SortingValuesEnum {
  Recent = 'recent',
  Popular = 'popular',
  Distance = 'distance',
  Slope = 'slopeAsc',
  Duration = 'duration',
  Difficulty = 'difficulty',
}

export interface BrowseSorting {
  label: string;
  value: SortingValuesEnum;
}

export const getSortings = () => {
  return [...sortings].map((sorting) => {
    return { ...sorting };
  });
};

const sortings: BrowseSorting[] = [
  {
    label: `browse.filterSort.sorts.options.${SortingValuesEnum.Recent}`,
    value: SortingValuesEnum.Recent,
  },
  {
    label: `browse.filterSort.sorts.options.${SortingValuesEnum.Popular}`,
    value: SortingValuesEnum.Popular,
  },
  {
    label: `browse.filterSort.sorts.options.${SortingValuesEnum.Distance}`,
    value: SortingValuesEnum.Distance,
  },
  {
    label: `browse.filterSort.sorts.options.${SortingValuesEnum.Difficulty}`,
    value: SortingValuesEnum.Difficulty,
  },
  {
    label: `browse.filterSort.sorts.options.${SortingValuesEnum.Duration}`,
    value: SortingValuesEnum.Duration,
  },
  {
    label: `browse.filterSort.sorts.options.slope`,
    value: SortingValuesEnum.Slope,
  },
];
